const React = require('react');
const ControlledDateTimeField = require('./ControlledDateTimeField');
const FieldContext = require('./FieldContext');

module.exports = function FormDateTimeField(props) {

    const {
        field = {},
        fieldName = field.name,
        label = field.label,
        onBlur,
        onChange,
        onFocus,
        pickerProps = field.pickerProps || {},
        setValue,
        textFieldProps = {},
        useField: requestedUseFieldHook,
        value
    } = props;

    const resolvedUseField = typeof requestedUseFieldHook === 'function'
        ? requestedUseFieldHook
        : FieldContext.useField;

    const fieldController = resolvedUseField(fieldName);
    const resolvedValue = typeof value === 'undefined'
        ? fieldController.getValue()
        : value;
    const setFieldValue = typeof setValue === 'function'
        ? setValue
        : fieldController.setValue;

    return <ControlledDateTimeField
        label={label}
        value={resolvedValue}
        onBlur={(event) => {
            fieldController.onBlur?.(event);
            onBlur?.(event);
        }}
        onChange={(nextValue, event) => {

            setFieldValue(nextValue, event);

            if (typeof onChange === 'function') {
                onChange(nextValue, event);
            }
        }}
        onFocus={(event) => {
            fieldController.onFocus?.(event);
            onFocus?.(event);
        }}
        pickerProps={pickerProps}
        textFieldProps={textFieldProps}
    />;
};
